// @ts-nocheck
import { useParams } from "react-router-dom"
import { useProfileData } from "@/lib/hooks/useProfileData"
import { ProfileHeader } from "@/components/profile/ProfileHeader"
import { ProfileTabs } from "@/components/profile/ProfileTabs"
import { ProfilePostList } from "@/components/profile/ProfilePostList"
import { useAuth } from "@/components/layout/AuthProvider"
import { FeedSkeleton } from "@/components/feed/FeedSkeleton"

export default function ProfilePage() {
  const { username } = useParams<{ username: string }>()
  const { supabaseUser } = useAuth()
  const { profile, loading } = useProfileData(username || "")

  if (loading) return <FeedSkeleton />
  if (!profile) return <div className="container-narrow py-16 text-center text-text-muted">User not found</div>

  const isOwner = supabaseUser?.id === profile.id

  return (
    <div className="container-narrow py-0">
      <ProfileHeader profile={profile} userId={supabaseUser?.id || null} isOwner={isOwner} />
      <ProfileTabs profileId={profile.id} userId={supabaseUser?.id || null} />
    </div>
  )
}